import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyClo3AVwMLJQhcXnYZ3raTCM1gD3UU0G3w",
  authDomain: "live-market-trades.firebaseapp.com",
  projectId: "live-market-trades",
  storageBucket: "live-market-trades.appspot.com",
  messagingSenderId: "386856691326",
  appId: "1:386856691326:web:6b23f6921019efb4d51a2f",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
